export const VERSION = process.env.VERSION || 'Test version';
